export default __webpack_public_path__ + "static/media/tab2.2b460d68.svg";